<div class="loading-withdrawal" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>

<div class="checkout-wizard">
  <div class="checkout-steps-header">
    <div
      class="step-item"
      [ngClass]="{
        active: currentStep === 0,
        completed: currentStep > 0
      }"
      (click)="goToStep(0)"
    >
      <div class="step-icon" [ngStyle]="getStepIconStyle(0)">1</div>
      <div class="step-text">
        <div class="step-title">
          {{ "common.checkoutDeposit" | translate }}
        </div>
      </div>
    </div>

    <div class="step-divider"></div>

    <div
      class="step-item"
      [ngClass]="{
        active: currentStep === 1,
        disabled: !canGoToBankStep
      }"
      (click)="(currentStep === 1 || canGoToBankStep) && goToStep(1)"
    >
      <div class="step-icon">2</div>
      <div class="step-text">
        <div class="step-title">
          {{ "common.payer" | translate }}
        </div>
      </div>
    </div>
  </div>

  <div
    class="checkout-wizard-track"
    [style.transform]="'translateX(-' + currentStep * 100 + '%)'"
  >
    <div class="checkout-step">
      <div class="row mt-4">
        <div class="col-12">
          <div
            class="card sales-summary rounded-10 shadow"
            [ngStyle]="{ 'background-color': cardColor }"
          >
            <div class="card-header">
              <div class="card-title mb-0">
                {{ "common.checkoutDeposit" | translate }} -
                {{ idempotencyKey }}
              </div>
            </div>
            <div class="card-body">
              <form [formGroup]="cashIn">
                <div class="row">
                  <div class="col-xl-4 col-lg-4 col-sm-4">
                    <div class="form-group">
                      <label for="txtNomeFavorecido" class="form-label">
                        {{ "common.name" | translate }}
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        class="form-control"
                        [ngClass]="{
                          'is-invalid state-invalid':
                            cashIn.controls.nome.invalid && isSubmitted
                        }"
                        [formControl]="cashIn.controls.nome"
                        type="text"
                        name="nomeFavorecido"
                        id="txtNomeFavorecido"
                        [readonly]="true"
                      />
                      <div class="invalid-feedback">{{ nomeFeedBack }}</div>
                    </div>
                  </div>

                  <div class="col-xl-4 col-lg-4 col-sm-4">
                    <div class="form-group">
                      <label for="txtDocumentoFavorecido" class="form-label">
                        {{ "common.document" | translate }}
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        [formControl]="cashIn.controls.documento"
                        class="form-control"
                        [ngClass]="{
                          'is-invalid state-invalid':
                            cashIn.controls.documento.invalid && isSubmitted
                        }"
                        type="text"
                        name="documentoFavorecido"
                        id="txtDocumentoFavorecido"
                        [readonly]="true"
                      />
                      <div class="invalid-feedback">
                        {{ documentFeedBack }}
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-4 col-lg-4 col-sm-4">
                    <div class="form-group">
                      <label for="txtDocumentoFavorecido" class="form-label">
                        {{ "common.email" | translate }}
                      </label>
                      <input
                        [formControl]="cashIn.controls.email"
                        class="form-control"
                        [ngClass]="{
                          'is-invalid state-invalid':
                            cashIn.controls.email.invalid && isSubmitted
                        }"
                        type="text"
                        name="documentoFavorecido"
                        id="txtDocumentoFavorecido"
                        [readonly]="true"
                      />
                      <div class="invalid-feedback">
                        {{ documentFeedBack }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-4 col-lg-4 col-sm-4">
                    <div class="form-group">
                      <label for="txtValorSolicitado" class="form-label">
                        {{ "common.value" | translate }}
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        placeholder="{{ currencyPrefix }} 0,00"
                        [formControl]="cashIn.controls.valor"
                        currencyMask
                        [options]="{
                          prefix: currencyPrefix ? currencyPrefix + ' ' : ''
                        }"
                        class="form-control"
                        [ngClass]="{
                          'is-invalid state-invalid':
                            cashIn.controls.valor.invalid && isSubmitted
                        }"
                        type="text"
                        [readonly]="true"
                        name="valorSolicitado"
                        id="txtValorSolicitado"
                        (focusout)="valorChanged()"
                      />
                      <div class="invalid-feedback">{{ valorFeedBack }}</div>
                    </div>
                  </div>

                  <div class="col-xl-4 col-lg-4 col-sm-4">
                    <label for="slOrigin" class="form-label">
                      {{ "common.paymentMethod" | translate }}
                    </label>
                    <ng-select
                      [items]="originList"
                      bindValue="value"
                      bindLabel="name"
                      [formControl]="cashIn.controls.paymentMethods"
                      [clearable]="false"
                      [searchable]="false"
                      appendTo="body"
                      [ngClass]="{
                        'is-invalid state-invalid':
                          cashIn.controls.paymentMethods.invalid && isSubmitted
                      }"
                    >
                    </ng-select>
                    <div class="invalid-feedback">{{ origemFeedBack }}</div>
                  </div>

                  <div
                    class="col-xl col-lg-3 col-sm-6 d-flex align-items-end mb-4"
                  >
                    <button
                      type="button"
                      class="our-button btn btn-pill"
                      (click)="onConfirmCheckout()"
                      [ngStyle]="{
                        'background-color': buttonColor,
                        'border-color': buttonColor,
                        color: '#fff'
                      }"
                    >
                      <i class="fe fe-check"></i>
                      {{ "common.confirmButton" | translate }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="checkout-step">
      <div class="row mt-4" *ngIf="countryForm && originCurrency !== 'MXN'">
        <div class="col-12">
          <div
            class="card rounded-10 shadow"
            [ngStyle]="{ 'background-color': cardColor }"
          >
            <div class="card-header">
              <div class="card-title mb-0">
                {{ "common.payer" | translate }}
              </div>
            </div>
            <div class="card-body">
              <form [formGroup]="countryForm">
                <div class="row">
                  <ng-container *ngFor="let f of currentCountryFields">
                    <div class="col-lg-6 col-sm-6 mb-3">
                      <label class="form-label">
                        {{ f.label | translate }}
                        <span class="text-danger">*</span>
                      </label>

                      <ng-container
                        *ngIf="
                          originCurrency === 'COP' && f.name === 'bankCode';
                          else docTypeOrInput
                        "
                      >
                        <ng-select
                          [items]="bankCodeOptions"
                          bindLabel="name"
                          bindValue="value"
                          [formControlName]="f.name"
                          [clearable]="false"
                          [searchable]="true"
                          [loading]="isLoadingBankCodes"
                          appendTo="body"
                          placeholder="{{ 'common.select' | translate }}"
                          [ngClass]="{
                            'is-invalid state-invalid':
                              countryForm.controls[f.name].invalid &&
                              isCountryFormSubmitted
                          }"
                        >
                        </ng-select>
                        <div
                          class="invalid-feedback"
                          *ngIf="
                            countryForm.controls[f.name].invalid &&
                            isCountryFormSubmitted
                          "
                        >
                          {{ "common.requiredField" | translate }}
                        </div>
                      </ng-container>

                      <ng-template #docTypeOrInput>
                        <!-- COP: documentType com select -->
                        <ng-container
                          *ngIf="
                            originCurrency === 'COP' &&
                              f.name === 'documentType';
                            else clpDocTypeOrInput
                          "
                        >
                          <select
                            class="form-control"
                            [formControlName]="f.name"
                            [ngClass]="{
                              'is-invalid state-invalid':
                                countryForm.controls[f.name].invalid &&
                                isCountryFormSubmitted
                            }"
                          >
                            <option
                              *ngFor="let t of copDocumentTypes"
                              [ngValue]="t.value"
                            >
                              {{ t.label }}
                            </option>
                          </select>
                          <div
                            class="invalid-feedback"
                            *ngIf="
                              countryForm.controls[f.name].invalid &&
                              isCountryFormSubmitted
                            "
                          >
                            {{ "common.requiredField" | translate }}
                          </div>
                        </ng-container>

                        <!-- CLP: documentType com select -->
                        <ng-template #clpDocTypeOrInput>
                          <ng-container
                            *ngIf="
                              originCurrency === 'CLP' &&
                                f.name === 'documentType';
                              else penDocTypeOrDefault
                            "
                          >
                            <select
                              class="form-control"
                              [formControlName]="f.name"
                              [ngClass]="{
                                'is-invalid state-invalid':
                                  countryForm.controls[f.name].invalid &&
                                  isCountryFormSubmitted
                              }"
                            >
                              <option
                                *ngFor="let t of clpDocumentTypes"
                                [ngValue]="t.value"
                              >
                                {{ t.label }}
                              </option>
                            </select>
                            <div
                              class="invalid-feedback"
                              *ngIf="
                                countryForm.controls[f.name].invalid &&
                                isCountryFormSubmitted
                              "
                            >
                              {{ "common.requiredField" | translate }}
                            </div>
                          </ng-container>
                        </ng-template>

                        <ng-template #penDocTypeOrDefault>
                          <ng-container
                            *ngIf="
                              originCurrency === 'PEN' &&
                                f.name === 'documentType';
                              else defaultInput
                            "
                          >
                            <select
                              class="form-control"
                              [formControlName]="f.name"
                              [ngClass]="{
                                'is-invalid state-invalid':
                                  countryForm.controls[f.name].invalid &&
                                  isCountryFormSubmitted
                              }"
                            >
                              <option
                                *ngFor="let t of penDocumentTypes"
                                [ngValue]="t.value"
                              >
                                {{ t.label }}
                              </option>
                            </select>
                            <div
                              class="invalid-feedback"
                              *ngIf="
                                countryForm.controls[f.name].invalid &&
                                isCountryFormSubmitted
                              "
                            >
                              {{ "common.requiredField" | translate }}
                            </div>
                          </ng-container>
                        </ng-template>

                        <ng-template #defaultInput>
                          <input
                            class="form-control"
                            [formControlName]="f.name"
                            [ngClass]="{
                              'is-invalid state-invalid':
                                countryForm.controls[f.name].invalid &&
                                isCountryFormSubmitted
                            }"
                          />
                          <div
                            class="invalid-feedback"
                            *ngIf="
                              countryForm.controls[f.name].invalid &&
                              isCountryFormSubmitted
                            "
                          >
                            {{ "common.requiredField" | translate }}
                          </div>
                        </ng-template>
                      </ng-template>
                    </div>
                  </ng-container>
                </div>

                <div class="step-actions">
                  <button
                    type="button"
                    class="our-button btn btn-pill"
                    (click)="goToStep(0)"
                    [ngStyle]="{
                      'background-color': buttonColor,
                      'border-color': buttonColor,
                      color: '#fff'
                    }"
                  >
                    <i class="fe fe-arrow-left me-1"></i>
                    {{ "common.back" | translate }}
                  </button>

                  <button
                    type="button"
                    class="our-button btn btn-pill"
                    (click)="confirmCountryForm()"
                    [ngStyle]="{
                      'background-color': buttonColor,
                      'border-color': buttonColor,
                      color: '#fff'
                    }"
                  >
                    <i class="fe fe-check"></i>
                    {{ "common.confirmButton" | translate }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
